import { Vue, Prop, Watch, Component } from 'vue-property-decorator';
import SiteStockConfig from '@/views/components/siteStockConfig'; // 库存取值设置
import ProductFilterConfig from '@/views/components/productFilterConfig'; // 库存取值设置
import BlackList from '@/views/components/blackList/blackList.vue';
import BookingTryOnAndExample from '@/views/components/bookingTryOnAndExample/bookingTryOnAndExample.vue'; // 预约试穿及出样
import SearchRecommend from '@/views/components/searchRecommend';
import SearchKeywords from '@/views/components/searchKeywords';
import LiveVideo from '@/views/components/liveVideo';
import PriceTag from '@/views/components/priceTag';

@Component({
  components: {
    SiteStockConfig,
    BlackList,
    BookingTryOnAndExample,
    ProductFilterConfig,
    SearchRecommend,
    SearchKeywords,
    LiveVideo,
    PriceTag,
  },
})
export default class FunctionConfig extends Vue {
  // 运营模式 1 镜单 2 镜千 3 云单 4 云千
  @Prop()
    mode: number | string;

  siteId = 0;

  curTab = '0';
  mounted() {
    this.curTab = localStorage.getItem('curTab') ? localStorage.getItem('curTab') : '0';
    this.siteId = +this.$route.params.siteId;
  }

  render(h) {
    return (
      <el-container class="categoryConfig height-100">
        <el-aside width="100%">
          <el-tabs tab-position="left" class="el-tabs" v-model={this.curTab}>
            <el-tab-pane label="商品筛选项配置" class="el-tab-pane" name="0">
              {this.curTab == '0' && +this.mode === 2 && <ProductFilterConfig />}
            </el-tab-pane>
            <el-tab-pane label="搜索关键词" class="el-tab-pane" name="1">
              {this.curTab == '1' && +this.mode === 2 && <SearchKeywords siteId={this.siteId} />}
            </el-tab-pane>
            <el-tab-pane label="搜索推荐" class="el-tab-pane" name="2">
              {this.curTab == '2' && +this.mode === 2 && <SearchRecommend siteId={this.siteId} />}
            </el-tab-pane>
            <el-tab-pane label="预约试穿及出样" class="el-tab-pane" name="3">
              {this.curTab == '3' && <BookingTryOnAndExample />}
            </el-tab-pane>
            <el-tab-pane label="网点库存取值" class="el-tab-pane" name="4">
              {this.curTab == '4' && <SiteStockConfig />}
            </el-tab-pane>
            <el-tab-pane label="黑名单" class="el-tab-pane" name="5">
              {this.curTab == '5' && <BlackList />}
            </el-tab-pane>
            <el-tab-pane label="直播视频拉取" class="el-tab-pane" name="6">
              {this.curTab == '6' && <LiveVideo />}
            </el-tab-pane>
            <el-tab-pane label="价格标签" class="el-tab-pane" name="7">
              {this.curTab == '7' && <PriceTag />}
            </el-tab-pane>
          </el-tabs>
        </el-aside>
      </el-container>
    );
  }
}
